export interface CurrencyConfig {
  code: string;
  symbol: string;
  name: string;
  locale: string;
  /** Conversion rate from USD */
  rateFromUSD: number;
}

export const COUNTRY_CURRENCIES: Record<string, CurrencyConfig> = {
  MR: {
    code: 'MRU',
    symbol: 'MRU',
    name: 'Ouguiya',
    locale: 'fr-MR',
    rateFromUSD: 39.5,
  },
  SN: {
    code: 'XOF',
    symbol: 'CFA',
    name: 'Franc CFA',
    locale: 'fr-SN',
    rateFromUSD: 620,
  },
  ML: {
    code: 'XOF',
    symbol: 'CFA',
    name: 'Franc CFA',
    locale: 'fr-ML',
    rateFromUSD: 620,
  },
  CI: {
    code: 'XOF',
    symbol: 'CFA',
    name: 'Franc CFA',
    locale: 'fr-CI',
    rateFromUSD: 620,
  },
  BF: {
    code: 'XOF',
    symbol: 'CFA',
    name: 'Franc CFA',
    locale: 'fr-BF',
    rateFromUSD: 620,
  },
};

/** Get currency config for a country code, defaults to MR */
export function getCurrencyForCountry(countryCode: string): CurrencyConfig {
  return COUNTRY_CURRENCIES[countryCode] ?? COUNTRY_CURRENCIES['MR'];
}

/** Format a number with thousands separator (space-separated, no locale API) */
function formatThousands(n: number): string {
  return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0');
}

/** Format a USD amount into the local currency */
export function formatLocalPrice(usdAmount: number, countryCode: string): string {
  const cfg = getCurrencyForCountry(countryCode);
  const localAmount = Math.round(usdAmount * cfg.rateFromUSD);
  return `${formatThousands(localAmount)} ${cfg.symbol}`;
}

/** Format a USD range (e.g. "95–140") into local currency */
export function formatLocalRange(usdMin: number, usdMax: number, countryCode: string): string {
  const cfg = getCurrencyForCountry(countryCode);
  const localMin = Math.round(usdMin * cfg.rateFromUSD);
  const localMax = Math.round(usdMax * cfg.rateFromUSD);
  return `${formatThousands(localMin)}–${formatThousands(localMax)} ${cfg.symbol}`;
}
